module.exports = __webpack_public_path__ + "static/media/sanfrancisco.1255b009.jpg";